export default {
  info: {
    name: '姓名',
    sex: '性别',
    mobile: '手机号码',
    age: '年龄',
    userId: '身份证',
    email: '邮箱',
    officeId: '所属机构',
    officeName: '所属机构',
    deptId: '所属部门',
    deptName: '所属部门',
    positionStatus: '任职状态',
    no: '工号',
    entryDate: '入职日期',
    password: '原密码',
    newPassword: '新密码',
    surePassword: '确认密码',
    tabsTitle: ['基础资料', '密码修改'],
    diffPwd: '两次输入密码不一致',
    requiredPwd: '请输入密码',
    requiredNewPwd: '请输入新密码',
    requiredCheckNewPwd: '请再次输入新密码'
  }
}
